"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ParticipantsPicker/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _hooks = require('web/services/hooks');






var _chatParticipantQuotas = require('shared/constants/chatParticipantQuotas');
var _contact = require('shared/enum/contact');
var _features = require('shared/enum/features'); var _features2 = _interopRequireDefault(_features);
var _uuid = require('shared/services/uuid');
var _upgrade = require('shared/enum/upgrade');
var _entity = require('shared/services/entity');
var _versionGuards = require('shared/services/versionGuards');






var _org = require('shared/selectors/org');
var _createNew = require('shared/hooks/createNew');
var _hooks3 = require('./hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);

var _SearchInput = require('./SearchInput'); var _SearchInput2 = _interopRequireDefault(_SearchInput);
var _ResultsList = require('./ResultsList'); var _ResultsList2 = _interopRequireDefault(_ResultsList);
var _InviteContactModal = require('web/screens/InviteContactModal'); var _InviteContactModal2 = _interopRequireDefault(_InviteContactModal);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);


























const ParticipantsPicker = ({
  orgKeyContext,
  excludedEntitiesMap,
  excludeOrgKey,
  selectedEntitiesList,
  onSelectEntity,
  onRemoveEntity,
  className,
  inputClassName,
  isInitiallyOpen = false,
  shouldRefocusOnPick = false,
  canInviteCoworkers = true,
  canInviteCollaborators = true,
  participantQuotas = _chatParticipantQuotas.NULL_QUOTA,
  senderSelect,
  onLookup,
  pinnedOrgKey = null,
  patientPinnedOrgKey = null,
  crossOrgPatients = false,
  isNewConversation = false,
  onReleaseSenderPin,
}) => {
  const orgName = _hooks.useAppSelector.call(void 0, s => _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, orgKeyContext, s), 'optionalAccess', _ => _.Name]), () => ( '')))
  const isOrgValid = orgKeyContext && orgKeyContext !== _uuid.EMPTY_BLUID
  const hasPatientMessaging =
    _hooks.useAppSelector.call(void 0, s => _org.selectOrgHasPatientMessagingFeature.call(void 0, s, orgKeyContext))
  const hasAnyPatientMessagingOrg = _hooks.useAppSelector.call(void 0, s =>
    _org.selectPatientMessagingOrgs.call(void 0, s, _contact.CONTACT_REL_TYPES.PATIENT).length > 0,
  )
  const firstPatientMessagingOrgKey = _hooks.useAppSelector.call(void 0, s =>
    _nullishCoalesce(_optionalChain([_org.selectPatientMessagingOrgs.call(void 0, s, _contact.CONTACT_REL_TYPES.PATIENT), 'access', _2 => _2[0], 'optionalAccess', _3 => _3.OrgKey]), () => ( null)),
  )
  const pinnedOrgHasPatientMessaging = _hooks.useAppSelector.call(void 0, s =>
    !!pinnedOrgKey
    && _org.selectOrgHasPatientMessagingFeature.call(void 0, s, pinnedOrgKey),
  )
  // The create-flow lock deliberately follows the sender-derived full pin.
  const canInvitePatientForDraft = crossOrgPatients
    ? (pinnedOrgKey ? pinnedOrgHasPatientMessaging : hasAnyPatientMessagingOrg)
    : hasPatientMessaging
  const patientInviteOrgKey = canInvitePatientForDraft
    ? pinnedOrgKey
      || (hasPatientMessaging ? orgKeyContext : firstPatientMessagingOrgKey)
      || orgKeyContext
    : orgKeyContext
  const patientInviteOrgName = _hooks.useAppSelector.call(void 0, s =>
    _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, patientInviteOrgKey, s), 'optionalAccess', _4 => _4.Name]), () => ( orgName)),
  )
  const orgsV1 = _hooks.useAppSelector.call(void 0, _org.selectOrgs)
  const [upgradeOrgKey, setUpgradeOrgKey] = _react.useState(null)

  const {
    canAddUsers,
    canAddTeams,
    canAddPatients,
    canAddParticipants,
  } = _createNew.useParticipantQuotas.call(void 0, selectedEntitiesList, participantQuotas)

  const {
    searchQuery,
    sanitizedSearchQuery,
    setSearchQuery,
    clearSearchQuery,
    searchContactType,
    isLoadingResults,
    internalEntitiesList,
    externalEntitiesList,
    patientEntitiesList,
  } = _createNew.useSearch.call(void 0, {
    listLimit: 4,
    orgKeyContext,
    canAddUsers,
    canAddTeams,
    canAddPatients,
    excludedEntitiesMap,
    onLookup,
    excludeOrgKey,
    crossOrgPatients,
  })

  const {
    isResultsListOpen,
    searchInputRef,
    openResultsList,
    closeResultsList,
    onEntitySelected,
  } = _hooks3.useResultsListState.call(void 0, {
    searchQuery: sanitizedSearchQuery,
    clearSearchQuery,
    isInitiallyOpen,
    shouldRefocusOnPick,
    canAddParticipants,
  })

  const {
    contactRelType,
    defaultContactCredentials,
    onOpenInviteContactModal,
    onCloseInviteContactModal,
  } = _hooks3.useInviteContact.call(void 0, searchQuery, searchContactType)

  const {
    isOpen: isUpgradeModalOpen,
    onOpen: onOpenUpgradeModal,
    onClose: onCloseUpgradeModal,
  } = _useToggle2.default.call(void 0, )

  const getDisabled = _react.useCallback.call(void 0, 
    (entity) => {
      if (_entity.isEntityPatient.call(void 0, entity)) {
        return !!pinnedOrgKey
          && entity.wrappedEntity.OrgKey !== pinnedOrgKey
      }
      return _entity.isEntityTeam.call(void 0, entity)
        && !!patientPinnedOrgKey
        && entity.wrappedEntity.OrgKey !== patientPinnedOrgKey
    },
    [patientPinnedOrgKey, pinnedOrgKey],
  )
  const handleSetContactType = _react.useCallback.call(void 0, 
    (t) => {
      if (t === _contact.CONTACT_REL_TYPES.PATIENT && !canInvitePatientForDraft) {
        setUpgradeOrgKey(pinnedOrgKey || orgKeyContext)
        return onOpenUpgradeModal()
      }
      return onOpenInviteContactModal(t)
    },
    [
      canInvitePatientForDraft,
      onOpenInviteContactModal,
      onOpenUpgradeModal,
      orgKeyContext,
      pinnedOrgKey,
    ],
  )
  const handleSelectEntity = _react.useCallback.call(void 0, 
    (e) => {
      if (getDisabled(e)) return
      if (_entity.isEntityPatient.call(void 0, e)) {
        const patientOrgKey = e.wrappedEntity.OrgKey
        const patientOrg = orgsV1[patientOrgKey] 
        const patientOrgIsV1Cached = !!patientOrg && _versionGuards.isOrgV1.call(void 0, patientOrg)
        const patientOrgHasMessaging =
          _org.orgHasFeature.call(void 0, patientOrg, _features2.default.PATIENT_MESSAGING)
        const isBlocked = crossOrgPatients
          ? patientOrgIsV1Cached && !patientOrgHasMessaging
          : !hasPatientMessaging
        if (isBlocked) {
          setUpgradeOrgKey(patientOrgKey)
          return onOpenUpgradeModal()
        }
      }
      // SAFETY: unchecked. EntityType is the caller's declaration of what the
      // picker offers (search results, invited contacts); nothing here narrows
      // to it, as when this parameter was an implicit any.
      onSelectEntity(e )
      onEntitySelected()
    },
    [
      crossOrgPatients,
      getDisabled,
      hasPatientMessaging,
      onSelectEntity,
      onEntitySelected,
      onOpenUpgradeModal,
      orgsV1,
    ],
  )

  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const handleInvitedEntity = _react.useCallback.call(void 0, 
    (e) => {
      const isPatientOutsidePin = _entity.isEntityPatient.call(void 0, e)
        && !!pinnedOrgKey
        && e.wrappedEntity.OrgKey !== pinnedOrgKey
      // Only a hand-picked From pinned the org, so the new patient's org wins.
      if (isPatientOutsidePin && !patientPinnedOrgKey && onReleaseSenderPin) {
        onReleaseSenderPin()
        // SAFETY: unchecked, as in handleSelectEntity below.
        onSelectEntity(e )
        onEntitySelected()
        return
      }
      if (getDisabled(e)) {
        // The contact exists now, so say why it isn't on the To line.
        const pinnedOrgName = pinnedOrgKey ? _optionalChain([orgsV1, 'access', _5 => _5[pinnedOrgKey], 'optionalAccess', _6 => _6.Name]) : ''
        const entityOrgName = _entity.isEntityPatient.call(void 0, e)
          ? _optionalChain([orgsV1, 'access', _7 => _7[e.wrappedEntity.OrgKey], 'optionalAccess', _8 => _8.Name])
          : ''
        showWarningBar(_entity.isEntityPatient.call(void 0, e) && entityOrgName && pinnedOrgName
          ? `${e.name} was added to ${entityOrgName}, but this conversation can only include patients from ${pinnedOrgName}.`
          : `${e.name} can't be added to this conversation.`)
        return
      }
      handleSelectEntity(e)
    },
    [
      getDisabled,
      handleSelectEntity,
      onEntitySelected,
      onReleaseSenderPin,
      onSelectEntity,
      orgsV1,
      patientPinnedOrgKey,
      pinnedOrgKey,
      showWarningBar,
    ],
  )

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, "participants-picker", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}
      , _react2.default.createElement(_SearchInput2.default, {
        ref: searchInputRef,
        className: inputClassName,
        onFocus: openResultsList,
        onBlur: closeResultsList,
        searchQuery: searchQuery,
        setSearchQuery: setSearchQuery,
        selectedEntitiesList: selectedEntitiesList,
        onRemoveSelectedEntity: onRemoveEntity,
        senderSelect: senderSelect,
        canAddParticipants: canAddParticipants, __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}
      )
      , _react2.default.createElement(_ResultsList2.default, {
        isOpen: isResultsListOpen,
        internalEntitiesList: internalEntitiesList,
        externalEntitiesList: externalEntitiesList,
        patientEntitiesList: patientEntitiesList,
        onSelectEntity: handleSelectEntity,
        searchQuery: searchQuery,
        searchContactType: searchContactType,
        isLoadingResults: isLoadingResults,
        orgName: orgName,
        patientOrgName: patientInviteOrgName,
        setContactRelType: handleSetContactType,
        canAddUsers: canAddUsers,
        canInviteCoworkers: canInviteCoworkers && isOrgValid,
        canInviteCollaborators: canInviteCollaborators,
        canAddPatients: canAddPatients && isOrgValid,
        searchInputRef: searchInputRef,
        getDisabled: getDisabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
      )
      , _react2.default.createElement(_InviteContactModal2.default, {
        isOpen: !!contactRelType,
        onClose: onCloseInviteContactModal,
        defaultPhone: defaultContactCredentials.phone,
        defaultEmail: defaultContactCredentials.email,
        defaultFirstName: defaultContactCredentials.firstName,
        defaultLastName: defaultContactCredentials.lastName,
        contactRelType: contactRelType,
        orgKeyContext: orgKeyContext,
        pinnedOrgKey: pinnedOrgKey,
        patientPinnedOrgKey: patientPinnedOrgKey,
        isNewConversation: isNewConversation,
        onEntityInvited: handleInvitedEntity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}
      )
      , _react2.default.createElement(_UpgradeModal2.default, {
        type: _upgrade.SubscriptionItemType.SMS,
        orgKey: _nullishCoalesce(upgradeOrgKey, () => ( orgKeyContext)),
        isOpen: isUpgradeModalOpen,
        onClose: onCloseUpgradeModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 315}}
      )
    )
  )
}

exports. default = ParticipantsPicker
